<template>
    <v-btn id="show-presets-button"
           ref="show-preset-button"
           v-if="!isGuest"
           @click="onClick"
           content="Presets"
           v-tippy="{placement: 'left'}"
           :class="{'animation-flash': addingPresetAnimation}"
           :disabled="isDisabled"
    >
        <v-icon class="material-symbols-outlined">bookmarks</v-icon>
    </v-btn>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],

    mounted() {
        this.$root.$refs.showPresetsButton = this.$refs['show-presets-button'];
    },
    computed: {
        ...mapGetters('User', ['isGuest', 'isCurrentPlanFree']),
        ...mapState("UI", ['addingPresetAnimation']),
        ...mapState("Projects", ["image"]),
        ...mapState("App", ["IDT", "blockLoading"]),
        isDisabled() {
            return !this.canUsePresets || !this.image;
        }
    },
    methods: {
        onClick() {
            if (!this.isCurrentPlanFree) {
                this.$store.dispatch("UserFiles/fetchPresets");
            }

            this.$store.dispatch('UI/setRightColumn', 'presets')
        },
    },
};
</script>

<style lang="scss" scoped>
#show-presets-button {
    &.animation-flash {
        animation: button-flash 1s infinite ease-in-out;
    }
}
</style>
